module.exports = __webpack_public_path__ + "static/assets/df846d3896f8ce4dfa45e6b7f174db78.png";